module.exports = new __parcel__URL__("welcome-to-project-pages-dark.99e9fdbd.png").toString();